import {Popover} from "bootstrap"

window.addEventListener("load", () => {
  $(".hotspot-popover").on("click", function (e) {
    $(this).toggleClass("popover-open")
    if ($(this).hasClass('popover-open')) {
      track('Product', 'Hotspot Opened', {hotspotType: 'image-zoom'})
    }
    e.preventDefault()
  })

  $(".hotspot-popover").on("focusout", function (e) {
    if (this.classList.contains("popover-open")) {
      $(this).toggleClass("popover-open")
      const popoverBtn = Popover.getInstance(this)
      popoverBtn.hide()
    }
    e.preventDefault()
  })
})
